import React from "react";
import "./Adv_banner.css";

function Adv_banner() {
  return (
    <>
      <section className="Adv_banner">
        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="Adv_banner_holder">
                <img
                  src="/assets/Images/Home/Adv_banner/img_1.png"
                  className="Adv_banner_img"
                  alt="Adv banner"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Adv_banner;
